import React from 'react';
import { AlertTriangle, LogOut, HelpCircle, FolderOpen } from 'lucide-react';

function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar', danger = true, icon = null }) {
  if (!isOpen) return null;

  const getIcon = () => {
    if (icon) return icon;
    if (danger) return <AlertTriangle size={32} />;
    if (title.toLowerCase().includes('sesión')) return <LogOut size={32} />;
    if (title.toLowerCase().includes('proyecto')) return <FolderOpen size={32} />;
    return <HelpCircle size={32} />;
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content confirm-modal" onClick={e => e.stopPropagation()}>
        <div className={`confirm-modal-icon ${danger ? 'danger' : 'info'}`}>
          {getIcon()}
        </div>
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="btn-secondary" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            className={`btn-primary ${danger ? 'btn-danger' : ''}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
